import { mapAssets } from '../utils';

export default (set, media) => set(
  () => ({
    assets: mapAssets(media)
  }),
  false,
  { type: 'media/updateMediaAssets', media }
);
